<template>
  <div
    class="tab-header"
    :class="{ 'flex horizontal': variant === 'horizontal' }"
  >
    <ul class="tab-list" :class="{ 'flex vertical': variant === 'vertical' }">
      <li v-for="(tab, index) in tabList" :key="index">
        <label
          :for="`${_uid}${index}`"
          :class="{ selected: index + 1 === activeTab }"
          v-text="tab"
        />
        <input
          :id="`${_uid}${index}`"
          v-model="activeTab"
          type="radio"
          :name="`${_uid}-tab`"
          :value="index + 1"
          class="hidden"
        />
      </li>
    </ul>
    <template v-for="(tab, index) in tabList">
      <div v-if="index + 1 === activeTab" :key="index">
        <slot :name="`tabPanel-${index + 1}`" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      required: true,
      default: () => [],
    },
    variant: {
      type: String,
      required: false,
      default: 'vertical',
      validator: value => ['horizontal', 'vertical'].includes(value),
    },
    headerClass: {
      type: Object,
      default: () => ({}),
    },
    contentClass: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      activeTab: 1,
    };
  },
};
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}

.flex {
  display: flex;
}

.tab-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  background-color: #252929;

  li label {
    color: #748286;
    display: block;
    font-weight: 600;
    font-size: 14px;
    &.selected {
      color: white;
    }

    &:hover {
      color: white;
      cursor: pointer;
    }
  }

  &.horizontal li label {
    border-left: solid 3px transparent;
    &.selected {
      border-left: solid 3px #db841e;
      background-color: #2c3233;
    }

    padding: 12px 30px 12px 27px;
  }

  &.vertical {
    text-align: center;

    li label {
      border-top: solid 3px transparent;
      &.selected {
        border-top: solid 3px #db841e;
        background-color: #2c3233;
      }

      padding: 9px 30px 12px 30px;
    }
  }
}
</style>
